module.exports = __webpack_public_path__ + "static/media/favorite__mix.0d5813f8.svg";